"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.getEventDateGroups = void 0;
var lodash_1 = __importDefault(require("lodash"));
var moment_timezone_1 = __importDefault(require("moment-timezone"));
var getEventDateGroups = function (allEvents, showHidden) {
    var _a;
    if (allEvents === void 0) { allEvents = []; }
    if (showHidden === void 0) { showHidden = false; }
    var events = showHidden ? allEvents : lodash_1["default"].reject(allEvents, "hidden");
    var eventsWithDay = events.map(function (event) {
        var newEvent = __assign({ day: (0, moment_timezone_1["default"])(event.startTime).format("dddd Do MMM YYYY") }, event);
        return newEvent;
    });
    var groupedByDay = (0, lodash_1["default"])(eventsWithDay)
        .groupBy(function (_a) {
        var day = _a.day;
        return day;
    })
        .value();
    var newDateGroups = [];
    var _loop_1 = function (i) {
        var key = lodash_1["default"].keys(groupedByDay)[i];
        var sortedEvents = groupedByDay[key].sort(function (dateA, dateB) {
            var stateTimeA = dateA.startTime;
            var stateTimeB = dateB.startTime;
            if ((0, moment_timezone_1["default"])(stateTimeA).isAfter(stateTimeB)) {
                return 1;
            }
            if ((0, moment_timezone_1["default"])(stateTimeB).isAfter(stateTimeA)) {
                return -1;
            }
            return 0;
        });
        var eventsWithBreaks = [];
        lodash_1["default"].forEach(sortedEvents, function (event, index) {
            var _a;
            var prevEventEnd = (_a = sortedEvents[index - 1]) === null || _a === void 0 ? void 0 : _a.endTime;
            if (prevEventEnd) {
                var minutesApart = (0, moment_timezone_1["default"])(event.startTime).diff((0, moment_timezone_1["default"])(prevEventEnd), "minutes");
                if (minutesApart > 0) {
                    eventsWithBreaks.push({
                        startTime: prevEventEnd,
                        endTime: event.startTime,
                        lengthMinutes: minutesApart
                    });
                }
            }
            eventsWithBreaks.push(event);
        });
        if (sortedEvents.length > 0) {
            newDateGroups.push({
                day: key,
                startTime: eventsWithBreaks[0].startTime,
                endTime: ((_a = lodash_1["default"].last(eventsWithBreaks)) === null || _a === void 0 ? void 0 : _a.endTime) || "",
                events: eventsWithBreaks
            });
        }
    };
    for (var i = 0; i < lodash_1["default"].keys(groupedByDay).length; i += 1) {
        _loop_1(i);
    }
    return newDateGroups.sort(function (dateA, dateB) {
        var stateTimeA = dateA.startTime;
        var stateTimeB = dateB.startTime;
        if ((0, moment_timezone_1["default"])(stateTimeA).isAfter(stateTimeB)) {
            return 1;
        }
        if ((0, moment_timezone_1["default"])(stateTimeB).isAfter(stateTimeA)) {
            return -1;
        }
        return 0;
    });
};
exports.getEventDateGroups = getEventDateGroups;
//# sourceMappingURL=event-date-groups.js.map